import * as events from "./events";
import {numberWithCommas, uuid} from "../../app/helper";
import tagOrderType from "../../enums/tag-order-type";
import {selector} from "./selector";

const PageTagOrder = (function ($) {
    const orderOptions = window.orderOptions;

    function initEvents() {
        if (orderOptions.payment.deliveryPrice === undefined) {
            $(selector.deliveryPriceRow).hide();
        }

        // Move to body so Bootstrap backdrop z-index works correctly
        const categoryInfoModal = document.getElementById('categoryInfoModal');
        if (categoryInfoModal) {
            document.body.appendChild(categoryInfoModal);
        }

        events.initTags();

        const container = $('#tag_items_container');
        container.on('change', selector.radioBtnType, events.handleTagTypeChange);
        container.on('click', selector.btnRemoveTagItem, events.handleRemoveTag);
        container.on('input', selector.prepaidAmount, events.calculateTotals);
        container.on('input', selector.customizedText, events.calculateTotals);
        $(document).on('change', selector.form.customerType, events.toggleCustomerType);
        $(document).on('change', selector.form.country, events.countryChanged);
        $(document).on('change', selector.paymentMethod, events.paymentMethodChange);

        if ($(selector.form.country).length) {
            $(selector.form.country).trigger('change');
        } else {
            const hiddenCountry = $('input[name="country"]');
            if (hiddenCountry.length && hiddenCountry.val() === 'RS') {
                events.countryChanged({target: hiddenCountry[0]});
            }
        }

        $('#add_tag').on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            events.addTagRow(uuid(), tagOrderType.T4A);
        });

        if (window.amssMembership) {
            import('./amss-membership.js').then((m) => m.init());
            document.addEventListener('amss:membership-change', () => events.calculateTotals());
        }
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageTagOrder};
